import { UserState } from 'data/__generated__';

export const USER_STATES_LABELS: Record<UserState, string> = {
    [UserState.AddedToTeam]: "Ajouté à l'organisation",
    [UserState.Archived]: 'Archivé',
    [UserState.Banned]: 'Banni',
    [UserState.Created]: 'Créé',
    [UserState.Deleted]: 'Supprimé',
    [UserState.OnBoarding]: 'OnBoarding',
    [UserState.Regular]: 'Actif',
};

export const INITIAL_USER_STATES = [UserState.OnBoarding, UserState.Created, UserState.AddedToTeam];
